<template>
  <MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- Start of user register form -->
      <div class="container row">
        <div class="justify-content-center">
          <h4 class="fw-bold preview-title text-start">
            Applicant Profile Preview
          </h4>
          <div class="table-responsive">
            <table
              class="table table-bordered tbl-resume"
              style="width: 100%; border-collapse: collapse"
            >
              <!-- FIXED: 26 equal-width columns (A–Z) -->
              <colgroup>
                <col style="width: 3.85%" />
                <!-- A -->
                <col style="width: 3.85%" />
                <!-- B -->
                <col style="width: 3.85%" />
                <!-- C -->
                <col style="width: 3.85%" />
                <!-- D -->
                <col style="width: 3.85%" />
                <!-- E -->
                <col style="width: 3.85%" />
                <!-- F -->
                <col style="width: 3.85%" />
                <!-- G -->
                <col style="width: 3.85%" />
                <!-- H -->
                <col style="width: 3.85%" />
                <!-- I -->
                <col style="width: 3.85%" />
                <!-- J -->
                <col style="width: 3.85%" />
                <!-- K -->
                <col style="width: 3.85%" />
                <!-- L -->
                <col style="width: 3.85%" />
                <!-- M -->
                <col style="width: 3.85%" />
                <!-- N -->
                <col style="width: 3.85%" />
                <!-- O -->
                <col style="width: 3.85%" />
                <!-- P -->
                <col style="width: 3.85%" />
                <!-- Q -->
                <col style="width: 3.85%" />
                <!-- R -->
                <col style="width: 3.85%" />
                <!-- S -->
                <col style="width: 3.85%" />
                <!-- T -->
                <col style="width: 3.85%" />
                <!-- U -->
                <col style="width: 3.85%" />
                <!-- V -->
                <col style="width: 3.85%" />
                <!-- W -->
                <col style="width: 3.85%" />
                <!-- X -->
                <col style="width: 3.85%" />
                <!-- Y -->
                <col style="width: 3.85%" />
                <!-- Z -->
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="4" class="bg1">受入れ機関</td>
                  <td colspan="7">{{ supervising_org }}</td>
                  <td colspan="1" class="fw-bold">様</td>
                  <td
                    colspan="4"
                    rowspan="2"
                    style="
                      border-bottom: 1px solid rgba(0, 0, 0, 0);
                      border-right: 0px;
                    "
                  ></td>
                  <td colspan="7" rowspan="4" style="border-left: 0px">
                    <img
                      src="@/assets/site_img/image.png"
                      style="width: auto; height: auto"
                    />
                  </td>
                  <td
                    colspan="3"
                    rowspan="4"
                    class="tbl-resume fw-bold"
                    style="font-size: 50px"
                  >
                    {{ applicantList.uid }}
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg1">受入れ企業</td>
                  <td colspan="7">{{ implementing_org }}</td>
                  <td colspan="1" class="fw-bold">様</td>
                </tr>
                <tr>
                  <td colspan="4" class="bg1">面接日(Y/M/D)</td>
                  <td colspan="6" v-if="interviewDate">
                    {{ new Date(interviewDate).getFullYear() }}年
                    {{ new Date(interviewDate).getMonth() + 1 }}月
                    {{ new Date(interviewDate).getDate() }}日
                  </td>
                  <td colspan="6" v-else>No interview yet</td>
                  <td
                    colspan="6"
                    rowspan="2"
                    style="
                      border-left: 0px;
                      border-right: 0px;
                      letter-spacing: 16px;
                    "
                  >
                    <h4 class="text-center fw-bold">履 歴 書</h4>
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="10"
                    class="cellHeight"
                    style="border-right: 0px"
                  ></td>
                </tr>
                <tr>
                  <td colspan="2" rowspan="3" class="bg1">氏名<br />Name</td>
                  <td colspan="2" rowspan="2" class="bg1">カナ</td>
                  <td rowspan="2" colspan="10" class="fw-bold">
                    {{ applicantList.name_jp }}
                  </td>
                  <td colspan="2" rowspan="2" class="bg1">性別</td>
                  <td colspan="2">
                    <!-- male or female -->
                    <span v-if="applicantList.gender == 'M'">男</span>
                    <span v-else-if="applicantList.gender == 'F'">女</span>
                  </td>
                  <td rowspan="2" colspan="2" class="bg1">身長<br />(cm)</td>
                  <td rowspan="2" colspan="2">{{ applicantList.height }}cm</td>
                  <td rowspan="6" colspan="4" v-if="img_path">
                    <img
                      :src="img_path"
                      alt="profile image"
                      class="profile img-thumbnail"
                    />
                  </td>
                  <td rowspan="6" colspan="4" v-else>no photo for applicant</td>
                </tr>
                <tr>
                  <td colspan="2" class="cellHeight">
                    <span v-if="applicantList.marital_status == 'S'">
                      (未婚 )</span
                    >
                    <span v-else-if="applicantList.marital_status == 'M'">
                      (既婚)</span
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg1">英文</td>
                  <td colspan="10" class="fw-bold">
                    {{ applicantList.name_eng }}
                  </td>
                  <td colspan="2" class="bg1">年齢</td>
                  <td colspan="2">
                    {{ ageCalculation(formatDOB(applicantList.dob)) }}
                  </td>
                  <td colspan="2" class="bg1">体重<br />(kg)</td>
                  <td colspan="2">{{ applicantList.weight }}kg</td>
                </tr>
                <tr>
                  <td colspan="4" class="bg1">生年月日<br />date of birth</td>
                  <td colspan="6">
                    {{ new Date(applicantList.dob).getFullYear() }}年
                    {{ new Date(applicantList.dob).getMonth() + 1 }}月
                    {{ new Date(applicantList.dob).getDate() }}日 <br />( Y / M
                    / D )
                  </td>
                  <td colspan="2" class="bg1">
                    <span class="md-font">血液型<br />Blood group</span>
                  </td>
                  <td colspan="2">{{ applicantList.blood_type }}</td>
                  <td colspan="2" class="bg1">民族</td>
                  <td colspan="2">{{ this.applicantList.race }}</td>
                  <td colspan="2" class="bg1">宗教</td>
                  <td colspan="2">
                    <span v-if="applicantList.religion !== null">
                      {{ religions[applicantList.religion] }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg1">Residence Add</td>
                  <td colspan="14" class="text-start">
                    {{ applicantList.residence_address }}
                  </td>
                  <td rowspan="2" class="bg1">
                    <span class="md-font">出 <br />身<br />地</span>
                  </td>
                  <td colspan="2">
                    <span class="md-font">{{ birthStateJa }}</span>
                  </td>
                  <td>州</td>
                </tr>
                <tr>
                  <td colspan="4" class="bg1">Present Add</td>
                  <td colspan="14" class="text-start">
                    {{ applicantList.present_addr }}
                  </td>
                  <td colspan="2">
                    <span class="md-font">{{ birthCityJa }}</span>
                  </td>
                  <td>市</td>
                </tr>
                <tr>
                  <td colspan="2" rowspan="2" class="bg1">利き手</td>
                  <td colspan="2" rowspan="2">
                    <span v-if="applicantList.handedness === 'R'">右</span>
                    <span v-else>左</span>
                  </td>
                  <td colspan="2" rowspan="2" class="bg1">喫煙</td>
                  <td colspan="2" rowspan="2">
                    <span v-if="applicantList.smoking === 1">有</span>
                    <span v-else>無</span>
                  </td>
                  <td colspan="2" rowspan="2" class="bg1">飲酒</td>
                  <td colspan="2" rowspan="2">
                    <span v-if="applicantList.drinking === 1">有</span>
                    <span v-else>無</span>
                  </td>
                  <td colspan="2" rowspan="2" class="bg1">既往歴</td>
                  <td colspan="2" rowspan="2">
                    <span v-if="applicantList.medical_check === 1">有</span>
                    <span v-else>無</span>
                  </td>
                  <td colspan="10" class="bg1">視力</td>
                </tr>
                <tr>
                  <td colspan="5" class="bg1">裸眼</td>
                  <td colspan="5" class="bg1">矯正器具着用時</td>
                </tr>
                <tr>
                  <td colspan="2" rowspan="2" class="bg1">長所</td>
                  <td colspan="14" rowspan="2">{{ applicantList.strength }}</td>
                  <td colspan="2">右目</td>
                  <td colspan="3">{{ applicantList.eyesight_r }}</td>
                  <td colspan="2">右目</td>
                  <td colspan="3">{{ applicantList.glass_r }}</td>
                </tr>
                <tr>
                  <td colspan="2">左目</td>
                  <td colspan="3">{{ applicantList.eyesight_l }}</td>
                  <td colspan="2">左目</td>
                  <td colspan="3">{{ applicantList.glass_l }}</td>
                </tr>
                <tr>
                  <td colspan="2" class="bg1">短所</td>
                  <td colspan="14">{{ applicantList.weakness }}</td>
                  <td colspan="2">両目</td>
                  <td colspan="3">{{ applicantList.eyesight_botheye }}</td>
                  <td colspan="2">両目</td>
                  <td colspan="3">{{ applicantList.glass_botheye }}</td>
                </tr>
                <tr>
                  <td rowspan="2" colspan="4" class="bg1">外国渡航歴</td>
                  <td rowspan="2" colspan="6">{{ foreignTravelHistoryJa }}</td>
                  <td rowspan="2" colspan="4" class="bg1">他可能言語</td>
                  <td rowspan="2" colspan="6">{{ possibleLanguagesJa }}</td>
                  <td colspan="6" class="bg1">本人連絡先</td>
                </tr>
                <tr>
                  <td colspan="6" class="cellHeight">
                    {{ applicantList.cellphone }}
                  </td>
                </tr>
                <tr>
                  <td colspan="26" class="text-start fw-bold">
                    日本語能力資格•特定技能資格•免許等(License •Qualification)
                  </td>
                </tr>
                <tr>
                  <td colspan="5" class="bg1">取得日</td>
                  <td colspan="21" class="bg1">
                    日本語能力資格•特定技能資格•免許等
                  </td>
                </tr>
                <tr
                  v-for="(i, index) in license_and_qualifications"
                  :key="`data_row_${index}`"
                  style="border-top: double 1px #000"
                >
                  <td colspan="2" style="border-right: solid 1px #eeece1">
                    {{ i.acquired_date ? i.acquired_date.split("/")[0] : null }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    年
                  </td>
                  <td style="border-right: solid 1px #eeece1">
                    {{
                      i.acquired_date
                        ? parseInt(i.acquired_date.split("/")[1], 10)
                        : null
                    }}
                  </td>
                  <td class="bg1">月</td>
                  <td colspan="21" class="text-start">
                    {{ qualificationJa(i.category, i.qualification) }}
                  </td>
                </tr>
                <tr>
                  <td colspan="26" class="text-start fw-bold">
                    学歴(Education)
                  </td>
                </tr>
                <tr>
                  <td colspan="11" class="bg1">期間</td>
                  <td colspan="15" class="bg1">学校</td>
                </tr>
                <tr
                  v-for="(i, index) in edu_histo"
                  :key="`data_row_${index}`"
                  style="border-top: double 1px #000"
                >
                  <td colspan="2" style="border-right: solid 1px #eeece1">
                    {{ i.start_date ? i.start_date.split("/")[0] : null }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    年<br />(Y)
                  </td>
                  <td style="border-right: solid 1px #eeece1">
                    {{
                      i.start_date
                        ? parseInt(i.start_date.split("/")[1], 10)
                        : null
                    }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    月<br />(M)
                  </td>
                  <td class="bg4" style="border-right: solid 1px #eeece1">~</td>
                  <td colspan="2" style="border-right: solid 1px #eeece1">
                    {{ i.end_date ? i.end_date.split("/")[0] : null }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    年<br />(Y)
                  </td>
                  <td style="border-right: solid 1px #eeece1">
                    {{
                      i.end_date ? parseInt(i.end_date.split("/")[1], 10) : null
                    }}
                  </td>
                  <td class="bg1">月<br />(M)</td>
                  <td colspan="12">{{ i.school }}</td>
                  <td colspan="3">
                    <span v-if="i.edu_grade !== null">
                      {{ eduGrades[i.edu_grade] }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="26" class="text-start fw-bold">
                    職歴(Work Experience)
                  </td>
                </tr>
                <tr>
                  <td colspan="11" class="bg1">期間</td>
                  <td colspan="9" class="bg1">勤務先(業態)</td>
                  <td colspan="3" class="bg1">職種</td>
                  <td colspan="3" class="bg1">月給</td>
                </tr>
                <tr
                  style="border-top: double 1px #000"
                  v-for="i in worker_histo"
                  :key="i.id"
                >
                  <td colspan="2" style="border-right: solid 1px #eeece1">
                    {{ i.start_date ? i.start_date.split("/")[0] : null }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    年<br />(Y)
                  </td>
                  <td style="border-right: solid 1px #eeece1">
                    {{
                      i.start_date
                        ? parseInt(i.start_date.split("/")[1], 10)
                        : null
                    }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    月<br />(M)
                  </td>
                  <td class="bg4" style="border-right: solid 1px #eeece1">~</td>
                  <td colspan="2" style="border-right: solid 1px #eeece1">
                    {{ i.end_date ? i.end_date.split("/")[0] : null }}
                  </td>
                  <td class="bg1" style="border-right: solid 1px #eeece1">
                    年<br />(Y)
                  </td>
                  <td style="border-right: solid 1px #eeece1">
                    {{
                      i.end_date ? parseInt(i.end_date.split("/")[1], 10) : null
                    }}
                  </td>
                  <td class="bg1">月<br />(M)</td>
                  <td colspan="9">{{ i.organization }}</td>
                  <td colspan="3">{{ i.position }}</td>
                  <td
                    colspan="3"
                    :style="{
                      fontSize: i.monthly_salary
                        ? Number(i.monthly_salary).toLocaleString().length > 8
                          ? '0.75rem'
                          : '0.9rem'
                        : '0.9rem',
                    }"
                  >
                    {{
                      i.monthly_salary
                        ? "LKR " + Number(i.monthly_salary).toLocaleString()
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="26" class="text-start fw-bold">
                    家族情報(Family Members)
                  </td>
                </tr>
                <tr>
                  <td rowspan="2" colspan="2" class="bg1">
                    続柄 <br />
                    Relations
                  </td>
                  <td rowspan="2" colspan="6" class="bg1">名前 <br />Name</td>
                  <td rowspan="2" colspan="2" class="bg1">年齢 <br />Age</td>
                  <td rowspan="2" colspan="6" class="bg1">
                    勤務先 <br />Place of Work
                  </td>
                  <td rowspan="2" colspan="2" class="bg1">
                    職種 <br />Occupations
                  </td>
                  <td colspan="2" class="bg1">
                    <span class="md-font">同居 <br />Live with</span>
                  </td>
                  <td style="border-bottom: solid 1px rgba(0, 0, 0, 0)"></td>
                  <td rowspan="2" colspan="5" class="bg1">年間目標貯金額</td>
                </tr>
                <tr>
                  <td class="bg1">有</td>
                  <td class="bg1">無</td>
                  <td style="border-bottom: solid 1px rgba(0, 0, 0, 0)"></td>
                </tr>
                <tr v-for="(i, index) in fam_member" :key="i.id">
                  <td colspan="2" class="cellHeight">{{ i.relations }}</td>
                  <td colspan="6">{{ i.name }}</td>
                  <td colspan="2">{{ i.age }}</td>
                  <td colspan="6">{{ i.work_place }}</td>
                  <td colspan="2">{{ i.occupations }}</td>
                  <td v-if="i.live_with == 1">√</td>
                  <td v-else></td>
                  <td v-if="i.live_with == 0">√</td>
                  <td v-else></td>
                  <td style="border-bottom: solid 1px rgba(0, 0, 0, 0)"></td>
                  <td v-if="index === 0" rowspan="2" colspan="5">
                    LKR
                    {{
                      Number(applicantList.annual_saving_goal).toLocaleString()
                    }}
                  </td>
                  <td v-if="index === 3" rowspan="2" colspan="5" class="bg1">
                    希望就労期間
                  </td>
                  <td v-if="index === 5" rowspan="2" colspan="5">
                    {{ applicantList.desired_employment_period }}年
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row d-flex justify-content-center my-3">
          <div class="col-md-6 col-sm-12 col-12 text-center">
            <button
              v-if="permission && permission.data.preview_edit === 1"
              v-on:click="edit_applicant_data(uid)"
              class="btn btn-edit col-12 fw-bold"
            >
              Go to Edit
            </button>
            <button
              v-if="permission && permission.data.preview_download === 1"
              class="btn btn-success col-12 fw-bold"
              v-on:click="download_single(uid)"
            >
              Download
            </button>
          </div>
        </div>
        <loading-modal
          :loading="loading_model.process_loading"
          :loading_text="loading_model.loading_text"
        ></loading-modal>
      </div>
      <!-- End of user register table -->
    </div>
  </MenuLayout>
</template>
<style lang="css" scoped src="@/assets/css/resume.css"></style>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import Resources from "@/Service/resources.js";
import { calculateAge } from "@/Util/calculateAge.js";
import LoadingModal from "@/components/LoadingModal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ConstantVar from "@/Service/constant-var.js";
import { swal_option } from "@/Util/swal-option.js";
import Swal from "sweetalert2";
import { mapState } from "vuex";
var dataService = new DataService();
var config = new Configuration();
var resource = new Resources();
var con_var = new ConstantVar();

export default {
  components: {
    MenuLayout,
    "loading-modal": LoadingModal,
    LoadingSpinner,
  },
  data() {
    return {
      applicantList: [],
      img_path: null,
      interviewDate: null,
      occuption_type: null,
      supervising_org: null,
      implementing_org: null,
      worker_histo: null,
      license_and_qualifications: null,
      edu_histo: null,
      fam_member: null,
      files: null,
      uid: null,
      loading: true, //データの取得
      loading_model: {},
      religions: [],
      eduGrades: [],
    };
  },
  async created() {
    if (this.$route.params.uid) {
      this.uid = this.$route.params.uid;
      var serverResponse = await dataService.retrieveWithGet(
        config.SERVICE_NAME_APPLICANT + "/" + this.uid,
      );
      if (serverResponse.success == true) {
        this.applicantList = serverResponse.data["applicants"];
        this.fam_member = serverResponse.data["family_members"];
        if (this.fam_member.length < 7) {
          for (let index = this.fam_member.length; index < 7; index++) {
            this.fam_member.push({
              name: null,
              relations: null,
              work_place: null,
              occupations: null,
            });
          }
        }
        this.worker_histo = serverResponse.data["work_histories"];
        if (this.worker_histo.length < 3) {
          for (let index = this.worker_histo.length; index < 3; index++) {
            this.worker_histo.push({
              start_date: null,
              end_date: null,
              organization: null,
              position: "",
            });
          }
        }
        this.edu_histo = serverResponse.data["education"];
        if (this.edu_histo.length < 3) {
          for (let index = this.edu_histo.length; index < 3; index++) {
            this.edu_histo.push({
              start_date: null,
              end_date: null,
              school: null,
              edu_grade: "",
            });
          }
        }
        this.license_and_qualifications =
          serverResponse.data["license_and_qualifications"];
        if (this.license_and_qualifications.length < 5) {
          for (
            let index = this.license_and_qualifications.length;
            index < 5;
            index++
          ) {
            this.license_and_qualifications.push({
              acquired_date: null,
              qualification: null,
            });
          }
        }
        // job transactions and interview date
        var job_tran = serverResponse.data["job_transactions"];
        if (job_tran) {
          this.interviewDate =
            serverResponse.data["job_transactions"].interview_date;
          this.occuption_type =
            serverResponse.data["job_transactions"].occupation_type;
          this.supervising_org =
            serverResponse.data["job_transactions"].supervision_organization;
          this.implementing_org =
            serverResponse.data["job_transactions"].implementing_organization;
        }
        if (serverResponse.data["files"]) {
          //ファイルパス
          for (const key in serverResponse.data["files"]) {
            if (serverResponse.data["files"][key].p_flg == 1) {
              this.img_path =
                resource.BACKEND_SIDE_BASE_URL +
                config.SERVICE_NAME_FILES +
                serverResponse.data["files"][key].path +
                "?t=" +
                Date.now();
            }
          }
        }
      } else if (
        serverResponse.success == false &&
        serverResponse.error == false
      ) {
        Swal.fire(swal_option("warn", serverResponse.message));
        this.$router.push("/applicantList");
      }
    }
    this.loading = false;
  },
  async mounted() {
    this.fetchReligions();
    this.fetchEduGrades();
  },
  computed: {
    ...mapState(["permission"]),
    birthStateJa() {
      const s = con_var.STATE.find(
        (s) => s.en === this.applicantList.birth_state,
      );
      return s ? s.ja : "";
    },
    birthCityJa() {
      const state = con_var.STATE.find(
        (s) => s.en === this.applicantList.birth_state,
      );

      if (!state) return "";

      const p = con_var.CITY[state.id]?.find(
        (p) => p.en === this.applicantList.birth_city,
      );

      return p ? p.ja : "";
    },
    foreignTravelHistoryJa() {
      if (!this.applicantList.foreign_travel_history) return "";

      const map = Object.fromEntries(
        con_var.TRAVEL_COUNTRY.map((c) => [c.en, c.ja]),
      );

      return this.applicantList.foreign_travel_history
        .split(",")
        .map((v) => map[v] || v)
        .join("、");
    },
    possibleLanguagesJa() {
      if (!this.applicantList.other_possible_languages) return "";

      const map = Object.fromEntries(con_var.LANGUAGE.map((c) => [c.en, c.ja]));

      return this.applicantList.other_possible_languages
        .split(",")
        .map((v) => map[v] || v)
        .join("、");
    },
  },
  methods: {
    // バックエンドから宗教データを取得する
    async fetchReligions() {
      const response = await dataService.retrieveWithGet(
        config.SERVICE_NAME_RELIGION,
      );
      this.religions = response;
    },
    // バックエンドから学歴データを取得する
    async fetchEduGrades() {
      const response = await dataService.retrieveWithGet(
        config.SERVICE_NAME_EDU_GRADE,
      );
      this.eduGrades = response;
    },
    qualificationJa(category, en) {
      const parsed = this.splitLicenseQualification(en);

      if (category === "IQTest") {
        return "IQテストの点数 -" + parsed.base;
      }

      const baseLabel =
        con_var.QUALIFICATION_OPTIONS[category]?.find(
          (q) => q.en === parsed.base,
        )?.ja || parsed.base;

      if (this.isLicenseStatusEnabled(category, parsed.base) && parsed.status) {
        return baseLabel + this.getLicenseStatusLabel(parsed.status);
      }

      return baseLabel;
    },
    isLicenseStatusEnabled(category, qualification) {
      return (
        ["japanese", "ssw"].includes(category) &&
        qualification &&
        qualification !== "Other"
      );
    },
    splitLicenseQualification(value) {
      if (!value || typeof value !== "string") {
        return { base: value || "", status: "" };
      }

      const match = value.match(/^(.*)\s+(Passed|Failed|Studying)$/);
      if (!match) {
        return { base: value, status: "" };
      }

      return {
        base: match[1].trim(),
        status: match[2],
      };
    },
    getLicenseStatusLabel(status) {
      const option = (con_var.QUALIFICATION_STATUS || []).find(
        (item) => item.value === status,
      );
      return option ? option.ja : "";
    },
    formatDOB(dob) {
      if (!dob) {
        return "";
      }
      const parts = dob.split("-");
      const formattedDOB = parts[0] + "/" + parts[1] + "/" + parts[2];
      return formattedDOB;
    },
    ageCalculation(dob) {
      return calculateAge(dob);
    },
    edit_applicant_data: function (uid) {
      this.$router.push({ name: "applicantRegister", params: { uid: uid } });
    },
    // 単一のエクセルシートをエクスポートする
    async download_single(uid) {
      let fileName;
      this.loading_model = {
        process_loading: true,
        loading_text: "Downloading",
      };
      try {
        const requestData = {
          uid,
        };
        const response = await dataService.downloadFileWithGet(
          config.SERVICE_NAME_APPLICANT_EXPORT_SINGLE,
          requestData,
        );
        this.downloadUid = "";
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition.includes("filename=")) {
          const matches = contentDisposition.match(/filename=([^;]+)/);
          if (matches && matches[1]) {
            fileName = matches[1].trim();
          }
        } else {
          console.error(
            "Unable to extract fileName from Content-Disposition header",
          );
        }
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
        this.loading_model = con_var.LOADING_MODEL;
        return response;
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
  },
};
</script>
